export const defaultListMaping = {
	'status': 'status',
	'data-current_page': 'current_page',
	'data-last_page': 'last_page',
	'data-total': 'total',
	'data-items': 'data',
	'data-take': 'take',
};
